import { GOOGLE_MAPS_API_CONFIG } from '@ng-maps/google';

import { environment } from '@manager/env';

export const googleMapsApiConfigProvider = {
  provide: GOOGLE_MAPS_API_CONFIG,
  useValue: {
    apiKey: environment.googleApi.apiKey,
    libraries: environment.googleApi.libraries,
    language: environment.googleApi.language,
    protocol: environment.googleApi.protocol,
  },
};
